// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 36) return "static/js/9d62ff778d6dce8a0853.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"e311a8d723464adf8d96","139":"2a6c8246055f30a93a61","140":"1614645e1230379b644a"}[chunkId] + ".chunk.js";
};